import React from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';

export default function WrappedAddControl({ className, label, wrapperComponent, onClick }) {
  if (wrapperComponent) {
    const WrapperComponent = wrapperComponent;
    return (
      <WrapperComponent onClick={onClick}>
        <AddControl className={className}>{label}</AddControl>
      </WrapperComponent>
    );
  } else {
    return <AddControl className={className} onClick={onClick}>{label}</AddControl>;
  }
}

WrappedAddControl.propTypes = {
  label: PropTypes.string.isRequired,
  wrapperComponent: PropTypes.func,
  onClick: PropTypes.func.isRequired,
};
